import React from "react";
import { Card, CardContent, Typography, Grid, CardHeader, Skeleton } from "@mui/material";
import SingleMarkerMap from "common/components/maps/SingleMarkerMap";
import MDTypography from "components/MDTypography";
import { Link } from "react-router-dom";

const HubGeneralInfoCard = ({ hub, isLoading }) => {
  return ( isLoading) ? (
    <Skeleton variant="rectangular" width="98%" height="98%" sx={{ mx: 1, borderRadius: 3 }} ></Skeleton>
  ) : (
    <Card>
      <CardHeader title="General Info"></CardHeader>
      <CardContent>
        <Grid container spacing={2} sx={{ fontSize: "1em" }}>
          <Grid item xs={12} md={6}>
            <MDTypography variant="body2" color="text">
              <b>Location:</b> {hub.location}{" "}
            </MDTypography>
            <MDTypography variant="body2" color="text">
              <b>RCX Point Name:</b> {hub.rcxPointName}{" "}
            </MDTypography>
            <MDTypography variant="body2" color="text">
              <b>Time Zone:</b> {hub.timeZone}{" "}
            </MDTypography>
            <MDTypography variant="body2" color="text">
              <b>Observe Daylight Savings Time:</b> {hub.useDaylightSavingsTime ? "True" : "False"}{" "}
            </MDTypography>
            <MDTypography variant="body2" color="text">
              <b>Lat/Long:</b> {hub.latitude} / {hub.longitude}
            </MDTypography>
            <MDTypography variant="body2" color="text">
              <b>Dispatch Contacts: </b>
              {hub.employees.map((e, i) => {
                return (
                  <Link color="info" key={i} to={`/employees/${e.employeeId}`}>
                    {e.firstName} {e.lastName}
                    {i != hub.employees.length - 1 ? ", " : ""}
                  </Link>
                );
              })}
            </MDTypography>
            <MDTypography variant="body2" color="text">
              <b>Address:</b> {hub.address1}, {hub.city}, {hub.state}
            </MDTypography>
             <MDTypography variant="body2" color="text">
              <b>Active:</b> {hub.isActive ? "True" : "False"}
            </MDTypography>
          </Grid>
          <Grid item xs={12} md={6}>
            <SingleMarkerMap location={{ latitude: hub.latitude, longitude: hub.longitude }} height={"41.5vh"} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
export default HubGeneralInfoCard;
